// IDs match the dedicated, external research citation ledger.
export const thanksSources = [
  {
    "id": 1,
    "url": "https://www.thomaslfriedman.com/thank-you-for-being-late/",
    "kind": "Auteur · présentation du livre · 2016",
    "title": "Thomas L. Friedman — Thank You for Being Late",
    "support": "Trois accélérations; innover et s’adapter, aider les personnes touchées, retrouver ses valeurs.",
    "limit": "Présentation de l’auteur, non validation scientifique de sa thèse."
  },
  {
    "id": 2,
    "url": "https://us.macmillan.com/books/9780374273538/thankyouforbeinglate/",
    "kind": "Éditeur · extrait public",
    "title": "Macmillan — Thank You for Being Late",
    "support": "Titre exact, auteur et ouverture sur les accélérations.",
    "limit": "Extrait public consulté seulement; aucune lecture intégrale revendiquée."
  },
  {
    "id": 3,
    "url": "https://www.nber.org/papers/w33795",
    "kind": "Recherche · NBER WP 33795 · révision novembre 2025",
    "title": "Dillon, Jaffe, Immorlica & Stanton — Shifting Work Patterns with Generative AI",
    "support": "Expérience randomisée : 66 entreprises, 7 137 travailleurs; gains individuels de temps sans transformation des tâches détectée.",
    "limit": "Résumé consulté; document de travail. Ne mesure ni la réussite de BZ ni le destin des entreprises non-adoptantes."
  },
  {
    "id": 4,
    "url": "https://www.mckinsey.com/capabilities/quantumblack/our-insights/the-state-of-ai-how-organizations-are-rewiring-to-capture-value",
    "kind": "Enquête · McKinsey · mars 2025",
    "title": "The state of AI: How organizations are rewiring to capture value",
    "support": "Refonte des processus, gouvernance et formation; associations avec impact financier déclaré.",
    "limit": "1 491 répondants, juillet 2024; autodéclarations et corrélations. Les chiffres ne sont pas des taux de réussite causaux."
  },
  {
    "id": 6,
    "url": "https://www.oecd.org/en/publications/generative-ai-and-the-sme-workforce_2d08b99d-en.html",
    "kind": "Enquête · OCDE · novembre 2025",
    "title": "Generative AI and the SME Workforce",
    "support": "Plus de 5 000 PME de sept pays, fin 2024 : usages, compétences, gains déclarés et freins à l’adoption.",
    "limit": "Résumé exécutif consulté. 31 % mesure un usage, pas la maturité ni un gain garanti. Non-adoption ne signifie pas immobilisme."
  },
  {
    "id": 8,
    "url": "https://www.carnegiecouncil.org/media/series/39/20170111-thank-you-for-being-late-an-optimists-guide-to-thriving-in-the-age-of-accelerations",
    "kind": "Source primaire · conférence transcrite · janvier 2017",
    "title": "Thomas Friedman au Carnegie Council",
    "support": "Pause, trois accélérations, repère autour de 2007, assistance intelligente, confiance et communautés.",
    "limit": "Transcription lue dans le navigateur. Sa note éditoriale nuance explicitement les dates autour de 2007; ce sont les propos de l’auteur, pas un test causal."
  }
] as const;
